import { ACTION } from '../reducers/relist';
import type { RelistAdditionalFieldsToRenderProps } from '../model/RelistAdditionalFields';

const updateRelistAdditionalFields =
  (relistAdditionalFields: RelistAdditionalFieldsToRenderProps, renderAdditionalDetailsPage: boolean) =>
  (
    dispatch: (arg: {
      type: string;
      payload: { fieldsToRender: RelistAdditionalFieldsToRenderProps; renderAdditionalDetailsPage: boolean };
    }) => void,
  ) =>
    dispatch({
      type: ACTION.UPDATE_ADDITIONAL_FIELDS_TO_RENDER,
      payload: { fieldsToRender: relistAdditionalFields, renderAdditionalDetailsPage },
    });

const RelistAdditionalFieldsActions = { updateRelistAdditionalFields };

export default RelistAdditionalFieldsActions;
